require('./app');
Vue.component('s-checkout', require('./components/frontend/Checkout.vue').default);
Vue.component('additional-info', require('./components/frontend/AdditionalInfo.vue').default);
Vue.component('s-stepper', require('./components/frontend/Stepper.vue').default);
Vue.component('s-spinner', require('./components/frontend/Spinner.vue').default);
Vue.component('ticket-selection-step', require('./components/frontend/TicketSelectionStep.vue').default);
Vue.component('single-ticket-selection-step', require('./components/frontend/SingleTicketSelectionStep.vue').default);
Vue.component('invoice-step', require('./components/frontend/InvoiceStep.vue').default);
Vue.component('payment-step', require('./components/frontend/PaymentStep.vue').default);
Vue.component('attendees-step', require('./components/frontend/AttendeesStep.vue').default);
Vue.component('attendee-form', require('./components/frontend/AttendeeForm.vue').default);
Vue.component('button-next', require('./components/frontend/ButtonNext.vue').default);
Vue.component('button-previous', require('./components/frontend/ButtonPrevious.vue').default);
Vue.component('price-box', require('./components/frontend/PriceBox.vue').default);
Vue.component('multi-ticket-info-box', require('./components/frontend/MultiTicketInfoBox.vue').default);
Vue.component('event-box', require('./components/frontend/EventBox.vue').default);
Vue.component('queue-dialog', require('./components/frontend/QueueDialog.vue').default);

Vue.component('success-card', require('./components/frontend/SuccessCard.vue').default);
Vue.component('failure-card', require('./components/frontend/FailureCard.vue').default);

Vue.component('s-footer', require('./components/Footer.vue').default);
Vue.component('s-legal-notice', require('./components/LegalNotice.vue').default);
Vue.component('s-terms', require('./components/Terms.vue').default);
Vue.component('s-privacy-policy', require('./components/PrivacyPolicy.vue').default);

const store = new Vuex.Store({
    state:{
        terms: false,
        legalNotice: false,
        privacyPolicy: false,
    },
    mutations: {
        setTerms(state, v) {
            state.terms = v;
        },
        setLegalNotice(state, v) {
            state.legalNotice = v;
        },
        setPrivacyPolicy(state, v) {
            state.privacyPolicy = v;
        }
    }
});

const app = new Vue({
    el: '#app',
    store,
    data: {
        csrf: ''
    }
});
